import { fetchRequest } from '../fetchUtil'
import { insuranceCompany, insuranceCompanyArray } from '../../schemas/insuranceCompanies'

import * as selectors from './selectors'

const API = '/api/insurance-companies'

export const GET_ALL = '@@insuranceCompanies/GET_ALL'
export const getAll = () => ({
  types: GET_ALL,
  meta: {
    fetch: fetchRequest.bind(null, API),
    normalize: insuranceCompanyArray,
    shouldFetch: (state) => {
      const deferreds = selectors.getDeferreds(state)
      if (deferreds.has('insuranceCompanies')) {
        return deferreds.get('insuranceCompanies').promise
      }
      if (selectors.isAllFetched(state)) {
        return Promise.resolve(selectors.getAll(state))
      }
      return undefined
    },
  },
})

export const ADD = '@@insuranceCompanies/ADD'
export const add = (data) => ({
  types: ADD,
  payload: { request: data },
  meta: {
    fetch: fetchRequest.bind(null, API, {
      body: JSON.stringify(data),
      method: 'POST',
    }),
    normalize: insuranceCompany,
  },
})

export const UPDATE = '@@insuranceCompanies/UPDATE'
export const update = (data) => ({
  types: UPDATE,
  payload: { request: data },
  meta: {
    fetch: fetchRequest.bind(null, API, {
      body: JSON.stringify(data),
      method: 'PATCH',
    }),
    notification: {
      success: {
        title: 'Mutual',
        content: 'Mutual actualizada.',
      },
    },
    normalize: insuranceCompany,
  },
})

export const REMOVE = '@@insuranceCompanies/REMOVE'
export const remove = ({ _id, replacementId }) => ({
  types: REMOVE,
  payload: { request: { _id, replacementId } },
  meta: {
    fetch: fetchRequest.bind(null, API, {
      body: JSON.stringify({ _id, replacementId }),
      method: 'DELETE',
    }),
    notification: {
      success: {
        title: 'Mutual',
        content: 'Mutual eliminada.',
      },
    },
  },
})

export const getAssignedCount = (_id) => (
  fetchRequest(`${API}/${_id}/assigned-count`)
)